module.exports = __webpack_public_path__ + "static/media/Carteirinha_SuaSaude_VF_Gerale.a7e1c025.png";